import * as React from 'react'
import { Box, Typography, Grid, Paper } from '@mui/material'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import CircularProgress from '@mui/material/CircularProgress';
export default function Overview() {

  const [progress, setProgress] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    setTimeout(() => setIsLoading(false), 2000);
  }, []);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 180);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Grid>

      {isLoading ? ( 
        <Grid display={'flex'} alignItems={'center'} justifyContent={'center'} height={'100vh'} sx={{backgroundColor:'primary.main'}}>
          <CircularProgress variant="determinate" color='secondary'  value={progress}  />
        </Grid>
         ) : (

      <Grid>
         <Box top={0} position={'sticky'}><Navbar/></Box>
         <Box overflow={'hidden'} sx={{ zIndex:'-12', position: 'relative',  height: '50vh' }}>
            <img
              src="/imgs/Bg1.jpg"
              alt="Background"
              style={{
                objectFit:'cover',
                width: '100%',
                height: '100%',
              }}
            />
      
              <Typography variant='h3'   color={'#fff'}  sx={{pl:'20%', pr:'80%',py:2, backgroundColor:'rgba(18, 37, 55,0.)',  position: 'absolute', bottom: 0, }}>
                Overview
              </Typography>
         </Box>
      
         {/* HOD Info*/}
         <Grid container xs={{ justifyContent: 'center' }} spacing={1} display={'flex'} sx={{py:'3%', m:0}}>
          <Grid item  md={3} > {/** Image with text */}
            <Grid container sx={{px:2}}>
              <Grid item xs={12}  > {/** Only Image */}
                <Box component={'img'} src='/imgs/Portrait1.jpg' width={'100%'}/>
              </Grid>
              <Grid item sx={{justifyContent:'center'}}>
                <Typography variant='h5'py={1} align='left'> Mr. Ramanjineya R</Typography>
                <Typography color={'#777'} align='left'>HOD-Library and Information Center</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11 }  md={8} >
            <Typography align='justify'>
            The HKBKCE Library is a resource centre for teaching, learning & research. Being the heart of the academic centre,
            it is home for all the information services. It plays a proactive role in enabling access to information resources of
            all kind and providing innovative, responsive and effective services to meet the changing needs of the academic community.<br/><br/>
            The major objective of our library is to provide authentic information to the student at any given point of time.
            The library is spread over two floors, state of art digital library, Reference Section, Journals/Magazines
            and Newspaper Sections are made available at the First floor and Stack Area, Circulation Counter,
            Students Discussion Rooms, OPAC Search at the Second floor of the library building. The library holds a hybrid collection of
            printed as well as electronic resources which include books, journals, databases, CDs/DVDs, e-books, e-journals,
            reports, course materials, previous years question papers, bound volumes, project reports, case studies,
            conference proceedings, etc. Currently the library holds over 51115 volumes, provides access to electronic resources,
            newspapers and magazines, and also have Institutional membership of VTU Consortium.
            </Typography>
          </Grid>
         </Grid>
      
         <Paper elevation={5}>
           <Grid container sx={{backgroundColor:'primary.main', justifyContent:'center', p:2, minHeight:'40vh'}}>
              <Grid item md={10}>
                <Typography variant='h6' fontWeight='bold' pb={2} align='left'> Vision</Typography>
              </Grid>
      
              <Grid item md={10}>
                <Typography align='justify'>
                HKBK aims to fulfil its vision and mission by providing all its stake holders with the widest possible resources
                in digital and print medium. The library provides the students and teaching community the relevant information
                to upgrade and polish their knowledge in order to compete and sustain in this competitive world. The committed
                staff of the library assists the knowledge promoting, locating, navigating and accessing the high-quality
                information resources.
                </Typography>
              </Grid>
           </Grid >
         </Paper>
         <Paper elevation={5}>
           <Grid container sx={{ justifyContent:'center', p:2, minHeight:'40vh'}}>
              <Grid item md={10}>
                <Typography variant='h6' fontWeight='bold' pb={2} align='left'> Mission</Typography>
              </Grid>
                <Grid item md={10}>
                  <Typography align='justify'>
                  The HKBK library thrives to strengthen and enhance the teaching, learning and research areas of the students as
                  well as the teaching community. The library facilitates to provide the future generation enough materials for
                  their intellectual growth with critical evaluation skill in well-equipped physical space. The learning space of
                  the institution recognizes and values diversity of the learners’ interest and accordingly develops and provides
                  the resources in consultation with of all faculty members of different departments. The library’s watch word is
                  to support and enhance the academic, professional, cultural and lifelong learning needs of the students with
                  proper resources, technology and the necessary 6  for the success in accomplishing the aforesaid mission.
                  </Typography>
                </Grid>
           </Grid >
         </Paper>
      
         <Footer/>
      
      
      </Grid>
     )}
    </Grid>
  )
}
